export default "__VITE_ASSET__C7Hy4tfQ__"